jQuery(function($) {
  
  $(document).ready(function() {
    
  });
  
  $(window).on( 'load', function () {
      
  });
  
  $(window).on( 'resize', function () {
      
  });
  
  $(window).scroll(function() {
      if ($(this).scrollTop()>0)
       {
          // $('.collection-shortcut-icons').fadeOut();
       }
      else
       {
        // $('.collection-shortcut-icons').fadeIn();
       }
   });
});

// IMPORTANT: Don't use "On Ready" in your code or Slick won't work with version 3.0 + of JQuery

$(".collection-shortcut-icons").slick({
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 12,
  slidesToScroll: 3,
  prevArrow: '<span class="slide-arrow prev-arrow"></span>',
  nextArrow: '<span class="slide-arrow next-arrow"></span>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: true
        }
      }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  
  
  
  
});

var headerHeight = document.getElementById('header').offsetHeight;
$('#shopify-section-header').css("margin-top", headerHeight);


var $div = $(".promo_banner");
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === "class") {
     var headerHeight = document.getElementById('header').offsetHeight;
     $('#shopify-section-header').css("margin-top", headerHeight);         
    }
  });
});
